import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ palette,variables }) => ({
/*   IOSNote: {
    marginBottom: variables?.spacingC
  },
  listItem: {
    borderBottom: `1px solid ${palette.jet?.borderDefault}`,
    margin: 0,
    '& .name-badge': {
      display: 'inline-block',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
    },
    '& .details-btn': {
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      border: `1px solid ${palette.jet?.borderDefault}`,
      padding: variables?.spacingB,
      width:'40px',
      height:'40px'
    },
    '& .listItemContent': {
      padding : `${variables?.spacingD} ${variables?.spacingG} ${variables?.spacingE} ${variables?.spacingJ}`,
      position: 'relative',
    },
  }, */
  courierCardWrapper: {
    marginBottom: variables?.spacingC,
  },
  courierCardContent: {

  },
  courierCardBody: {
    position:'relative',
    padding: variables?.spacingB,
    
    '& .details-btn': {
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      border: `1px solid ${palette.jet?.borderDefault}`,
      padding: variables?.spacingB,
      width:'40px',
      height:'40px'
    },
  },
  courierCardTitle: {
    marginBottom: variables?.spacingA
  }
}));

export default styles;
